





















import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            tempMessage: null,
            messageEmpty: null
        }
    },
    props: {
        insert: {
            type: String,
            default: null
        }
    },
    mounted() {
        //  Save message to temp variable
        this.tempMessage = this.insert
    },
    computed: {
        responsiveStyle(): string {
            return this.$vuetify.breakpoint.xsOnly ? 'min-width:95%;' : 'min-width:500px;'
        },
    },
    methods: {
        save(): void {
            //  If message is empty,
            if (!this.tempMessage) {
                //  Set messageEmpty to true, for rendering of messagetextform validation
                this.messageEmpty = true

                //  Apply shakeAnimation class to custom validations
                document.getElementById("messageArea").classList.add('shakeAnimation')

                //  Do nothing
                return
            }

            //  Else, emit submit with message.
            this.$emit('submit', this.tempMessage)
        }
    }
})
